import { render } from "./page9.vue?vue&type=template&id=2dc1a886&scoped=true"
import script from "./page9.vue?vue&type=script&lang=js"
export * from "./page9.vue?vue&type=script&lang=js"

import "./page9.vue?vue&type=style&index=0&id=2dc1a886&scoped=true&lang=less"

import exportComponent from "D:\\work\\mvgx-carbon-space-admin-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc1a886"]])

export default __exports__